import { ReactNode } from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForwardRounded";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

interface CalculatorCardProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  description: string;
  onOpen: () => void;
}

export function CalculatorCard({ icon, title, subtitle, description, onOpen }: CalculatorCardProps) {
  const { t } = useTranslation();

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack gap={2} sx={{ height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {icon}
          <Box>
            <Typography variant="h2">{title}</Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" sx={{ flex: 1 }}>
          {description}
        </Typography>

        <Box>
          <Button
            variant="text"
            endIcon={<ArrowForwardIcon />}
            onClick={onOpen}
            aria-label={t("calculators.openCalculator", { name: title })}
          >
            {t("calculators.open")}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}
